import React, { useState } from 'react';
import emailjs from 'emailjs-com';

export default function ContactMe() {
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_146hrdu';
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_zbher0i';
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'VYPDXcjOJNr6m3U7n';

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        topic: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent default form submission behavior (page refresh)
        
        emailjs.sendForm(serviceId, templateId, e.target, publicKey)
            .then(() => {
                alert('Message sent successfully!');
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    topic: '',
                    message: '',
                });
            })
            .catch((error) => {
                const errorMessage = error?.text || error?.message || 'Unknown EmailJS error';
                console.error('EmailJS send failed:', error);
                alert(`Failed to send message: ${errorMessage}`);
            });
    };
    return (
        <section id="Contact" className="contact--section">
            <div>
                <p className="sub--title">Get In Touch</p>
                <h2>Contact Me</h2>
                <p className="text-lg">
                    I'd love to hear from you! Feel free to send me a message using the form below, and I'll get back to you as soon as possible.
                </p>
            </div>
            <form className="contact--form--container" onSubmit={handleSubmit}>
                <div className="container">
                    <label htmlFor="firstName" className="contact--label">
                        <span className="text-md">First Name</span>
                        <input
                            type="text"
                            className="contact--input text-md"
                            name="firstName"
                            id="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label htmlFor="lastName" className="contact--label">
                        <span className="text-md">Last Name</span>
                        <input
                            type="text"
                            className="contact--input text-md"
                            name="lastName"
                            id="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label htmlFor="email" className="contact--label">
                        <span className="text-md">Email</span>
                        <input
                            type="email"
                            className="contact--input text-md"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </label>
                    <label htmlFor="phoneNumber" className="contact--label">
                        <span className="text-md">Phone Number</span>
                        <input
                            type="tel"
                            className="contact--input text-md"
                            name="phoneNumber"
                            id="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            required
                        />
                    </label>
                </div>
                <label htmlFor="choose-topic" className="contact--label">
                    <span className="text-md">Choose a topic</span>
                    <select
                        id="choose-topic"
                        name="topic"
                        className="contact--input text-md"
                        value={formData.topic}
                        onChange={handleChange}
                        required
                    >
                    <option value="">Select Topic...</option>
                    <option value="General Inquiry">General Inquiry</option>
                    <option value="Feedback">Feedback</option>
                    <option value="Job Opportunity">Job Opportunity</option>
                    </select>
                </label>
                <label htmlFor="message" className="contact--label">
                    <span className="text-md">Message</span>
                    <textarea
                    className="contact--input text-md"
                    name="message"
                    id="message"
                    rows="8"
                    placeholder="Type your message..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                    />
                </label>
                <div>
                    <button type="submit" className="btn btn-primary contact--form--btn">Submit</button>
                </div>
            </form>
      </section>
    );
}